import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'matchTypeReportPipe',
    pure: true // Ensures the pipe is pure for performance
    ,
    standalone: false
})
export class MatchTypeReportPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return '-';

    switch(value) {
      case 'MATCH': return 'Matching';
      case 'POTENTIAL_MATCH': return 'Partial Matching';
      case 'DUPLICATE': return 'Potential Duplicate';
      case 'NOT_MATCH': return 'Not Matching';
      default: return '-';
    }
  }
}
